const value = Object.freeze({
  Dashboard: 0,
  Summary: 1,
  Detail: 2,
  Property: 3,
  Accessory: 4,
});
export default value;
